import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader, Empty } from "./ui";
import { STATUS_LABEL, shortWhen } from "@/lib/format";
import { UpcomingSends } from "./UpcomingSends";

const CAT_ORDER = [["oracao", "Pedidos de oração"], ["deus_provera", "Solicitações Deus Proverá"], ["testemunho", "Testemunhos"],
  ["comprovante", "Comprovantes"], ["fotografia", "Fotografias"], ["informacoes", "Informações sobre a igreja"],
  ["outras", "Outras mensagens"], ["aguardando", "Aguardando classificação"]];

const Row = ({ to, label, value, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="group flex items-center justify-between gap-4 px-4 py-3 transition-colors hover:bg-zap-mist">
      <span className="text-[15px]">{label}</span>
      <span className="flex items-center gap-3"><span className="font-display text-lg font-semibold tabular-nums text-zap-ink">{value}</span><ArrowRight className="h-4 w-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" /></span>
    </Link>
  </li>
);

export default function Home() {
  const { api, me } = useOutletContext();
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setO(r.data)).catch(() => setO(false)); }, [api]);
  return (
    <div className="flex h-full flex-col">
      <PageHeader title={`Olá, ${me.name?.split(" ")[0] || "Administrador"}`} description="Situação atual dos atendimentos." />
      <div className="scroll-thin min-h-0 flex-1 overflow-y-auto">
        <UpcomingSends />
        {o === null ? <Empty>Carregando…</Empty> : o === false ? <Empty>Não foi possível carregar.</Empty> : (
          <div className="grid max-w-6xl gap-8 px-5 py-6 md:px-8 lg:grid-cols-3">
            <section className="space-y-2">
              <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Atendimentos por situação</h2>
              <ul data-testid="home-status" className="divide-y divide-zap-line rounded-lg border border-zap-line bg-white">
                {Object.entries(STATUS_LABEL).map(([k, l]) => (
                  <Row key={k} testId={`home-status-${k}`} to={k === "respondido" ? "/admin/conversas?f=respondidos" : "/admin/conversas?f=pendentes"} label={l} value={o.by_status[k] || 0} />
                ))}
              </ul>
              <p className="text-xs text-muted-foreground">{o.unread} conversa(s) com mensagens não lidas · {o.receipts_pending} comprovante(s) a conferir</p>
            </section>
            <section className="space-y-2">
              <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Pendentes por categoria</h2>
              <ul data-testid="home-categories" className="divide-y divide-zap-line rounded-lg border border-zap-line bg-white">
                {CAT_ORDER.map(([s, l]) => (
                  <Row key={s} testId={`home-cat-${s}`} to={s === "comprovante" ? "/admin/comprovantes" : `/admin/conversas?f=${s}`} label={l} value={o.pending_by_category[s] || 0} />
                ))}
              </ul>
            </section>
            <section className="space-y-2">
              <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Esperando há mais tempo</h2>
              {o.oldest_waiting.length === 0 ? <p data-testid="home-waiting-empty" className="rounded-lg border border-dashed border-zap-line p-4 text-sm text-muted-foreground">Nenhuma conversa aguardando primeira leitura.</p> : (
                <ul data-testid="home-waiting" className="divide-y divide-zap-line rounded-lg border border-zap-line bg-white">
                  {o.oldest_waiting.map((p) => (
                    <li key={p.id}>
                      <Link to={`/admin/conversas?p=${p.id}`} data-testid={`home-waiting-${p.id}`} className="block px-4 py-3 hover:bg-zap-mist">
                        <span className="flex justify-between gap-2"><span className="truncate font-semibold">{p.name}</span><span className="shrink-0 text-xs text-muted-foreground">{shortWhen(p.last_message_at)}</span></span>
                        <span className="block truncate text-sm text-muted-foreground">{p.last_message_preview}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </div>
        )}
      </div>
    </div>
  );
}
